/* Button styles from the prototype (.btn, .btn-add, .btn-wa, …). Compose: `${b.btn} ${b.wa}`. */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  padding: 8px 10px;
  border-radius: var(--r-s);
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.add {
  flex: 1;
  background: var(--brand-soft);
  color: var(--brand);
}

.wa {
  background: var(--wa);
  color: var(--wa-ink);
}

.waOutline {
  border: 1.5px solid var(--wa);
  color: var(--wa);
  padding: 6.5px 9px;
}

.primary {
  background: var(--brand);
  color: var(--brand-ink);
}

.ghost {
  border: 1.5px solid var(--line);
  background: var(--surface);
}

.lg {
  min-height: 46px;
  padding: 12px 16px;
  font-size: 15px;
  border-radius: var(--r-m);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.iconbtn {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--surface);
  color: var(--fg);
  box-shadow: var(--shadow);
}

.note {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}
